/* eslint-disable no-sequences */
import React from "react";
import Components from "mpm-components";
import { FormattedMessage } from "react-intl";
import { Form, Button, TextArea, Divider } from "semantic-ui-react";
import { toClasses } from "class-converter";
import {SourceEspeceView } from 'mpm-classes/CessionProduit'
import NumberFormat from "react-number-format";
export default ({ cessionProduit }) => {
    const [selectedSource, setSelectedSource] = React.useState(null);
    const [selectedSourceEspeces, setSelectedSourceEspeces] = React.useState([]);
  
    const onSelectSource = (source) => {
      setSelectedSource(null);
      setSelectedSourceEspeces([]);
      setTimeout(() => {
        setSelectedSourceEspeces(toClasses(source.childrenSrcEsp, SourceEspeceView ));
        setSelectedSource(source);
      }, 100);
      
    };
  
    return (
      <>
        <Components.Regions.RegionWithHeader
          title="label.type-source"
          headerColor="blue"
          headerSize="small"
        >
          <Components.Tables.SmartTable
            header={[
            
              {
                selector: "cp",
                textAlign: "center",
                label: <FormattedMessage tagName="label" id="menu.cession.product" />,
              },
              {
                selector: "cc",
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="menu.cession.capture" />
                ),
              },
              {
                collapsing: true,
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="label.table.actions" />
                ),
                component: (source) => (
                  <Button size="mini" onClick={() => onSelectSource(source)}>
                    {" "}
                    Détails Espèses{" "}
                  </Button>
                ),
              },
            ]}
            data={cessionProduit.childrenSourceCP}
            grouped={false}
            pagination={true}
            striped={true}
            sortable={true}
            rowsPerPage={5}
          />
        </Components.Regions.RegionWithHeader>
  
        {selectedSource && (
          <Components.Regions.RegionWithHeader
            title="label.especes"
            headerColor="blue"
            headerSize="small"
            className="scrolling-x"
          >
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  label="Type Source"
                  disabled
                  value={selectedSource.typeSource}
                />
                <Form.Input
                  label="Code Source"
                  disabled
                  value={selectedSource.codeSource}
                />
              </Form.Group>
            </Form>
            {selectedSourceEspeces && (<>
              <Components.Tables.SmartTable
                header={[
                  {
                    selector: "source",
                    textAlign: "center",
                    collapsing: true,
                    component: (row) => <TextArea value={row.source} onChange={() => {}}/>,
                    label: <FormattedMessage tagName="label" id="label.source" />,
                  },
                  {
                    selector: "nomNavire",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.navire" />,
                  },
                  {
                    selector: "refEspece.libelle",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.espece" />,
                  },{
                    selector: "transformation",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.type-transformation" />,
                  },{
                    selector: "autreTrans",
                    textAlign: "center",
                    label: <FormattedMessage tagName="label" id="label.autre-transformation" />,
                  },
                  {
                    selector: "disponible",
                    textAlign: "center",
                    label: "Disponible (KG)",
                    component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.' , ','} value={row.disponible} />
                  },
                  {
                    selector: "quantite",
                    textAlign: "center",
                    label: (
                      <>
                        <FormattedMessage
                          tagName="label"
                          id="label.table.espece.quantite"
                        />{" "}
                        (KG)
                      </>
                    ),
                    component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.quantite} />
                  },
                  {
                    selector: "poidCD",
                    textAlign: "center",
                    label: "Poids CD(KG)",
                    component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.poidCD} />

                  },
                  {
                    selector: "rendementG",
                    textAlign: "center",
                    label: "Rendement G",
                    component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.rendementG} />
                  },
                  {
                    selector: "rendementT",
                    textAlign: "center",
                    label: "Rendement T",
                    component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.rendementT} />
                  },
                ]}
                data={selectedSourceEspeces}
                grouped={false}
                pagination={true}
                striped={true}
                sortable={true}
                rowsPerPage={5}
              />
              <Divider />
              <Components.Tables.SmartTable
                      header={[
                        {
                          selector: "refEspece.libelle",
                          label: "Espece",
                        },
                        {
                          selector: "disponible",
                          textAlign: "center",
                          label: "Disponible (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.disponible} />
                        },
                        {
                          selector: "quantite",
                          textAlign: "center",
                          label: "Quantité cédée en (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.quantite} />
                        },
                        {
                          selector: "poidCD",
                          textAlign: "center",
                          label: "Poids CD (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} 
                            thousandSeparator=" " decimalScale={3} 
                            allowedDecimalSeparators={'.', ','} value={row.poidCD} />
                        },
                      
                      ]}
                      data={selectedSourceEspeces}
                      grouped={true}
                      hideGroupIcon
                      groupeBy="refEspece.libelle"
                      groupeSums={["disponible", "quantite", "poidCD"]}
                      rowsPerPage={5}
                      pagination={true}
                      striped={true}
                      sortable={false}
                    />
            </>
            )}
          </Components.Regions.RegionWithHeader>
        )}
      </>
    );
  };
  